import styled, { css } from 'styled-components';
export const Wrapper = styled.li`
  margin: 0;
  padding: 0;
  list-style: none;
  display: ${({ isLandscape }) => (isLandscape ? 'inline-block' : 'block')};
  position: relative;
  vertical-align: top;
  ${({ iconSize, isLandscape, isLast, totalSteps }) =>
    setSize(iconSize, isLandscape, isLast, totalSteps)}
`;

const setSize = (iconSize, isLandscape, isLast, totalSteps) => {
  if (isLandscape) {
    if (isLast)
      return css`
        width: ${iconSize};
      `;
    else
      return css`
        width: calc((100% - ${iconSize}px) / ${totalSteps - 1});
      `;
  } else {
    if (isLast)
      return css`
        height: ${iconSize};
      `;
    else {
      return css`
        height: calc((100% - ${iconSize}px) / ${totalSteps - 1});
      `;
    }
  }
};

export const Icon = styled.div`
  display: flex;
  flex-direction: row;
`;

export const IconWrapper = styled.div`
  height: ${({ iconSize }) => iconSize}px;
  width: ${({ iconSize }) => iconSize}px;
  border-radius: var(--border-radius-5);
  display: flex;
  justify-content: center;
  ${({ status }) => getStatusBgColor(status)}
`;

const getStatusBgColor = (status) => {
  switch (status) {
    case 'completed':
      return css`
        background-color: var(--success-bg);
      `;
    case 'active':
      return css`
        background-color: var(--primary-bg);
      `;
    case 'disabled':
      return css`
        background-color: var(--neutral-bg-strong);
      `;
  }
};

export const Label = styled.div`
  position: absolute;
  ${({ status, isLandscape }) => getLabelStatus(status, isLandscape)}
  ${({ isLandscape, iconSize }) => getLabelPosition(isLandscape, iconSize)}
`;

const getLabelStatus = (status, isLandscape) => {
  if (!isLandscape)
    return css`
      display: block;
    `;
  switch (status) {
    case 'completed':
      return css`
        display: none;
      `;
    case 'active':
      return css`
        display: block;
      `;
    case 'disabled':
      return css`
        display: none;
      `;
  }
};

const getLabelPosition = (isLandscape, iconSize) => {
  if (isLandscape)
    return css`
      top: calc(${iconSize}px + var(--spacing-3));
      left: calc(${iconSize / 2}px);
      transform: translate(-50%, 0);
      width: max-content;
    `;
  else
    return css`
      top: calc(${iconSize / 2}px);
      left: calc(${iconSize}px + var(--spacing-3));
      transform: translate(0, -50%);
    `;
};

export const Progress = styled.div`
  position: relative;
  width: ${({ isLandscape, iconSize }) =>
    isLandscape ? `calc(100% - ${iconSize}px)` : '100%'};
  height: ${({ isLandscape, iconSize }) =>
    !isLandscape ? `calc(100% - ${iconSize}px)` : '100%'};
  margin-left: ${({ isLandscape, iconSize }) =>
    isLandscape ? 0 : iconSize / 2}px;
  top: ${({ isLandscape, iconSize }) => (isLandscape ? -iconSize / 2 : 0)}px;
  left: ${({ isLandscape, iconSize }) => (isLandscape ? iconSize : 0)}px;
`;
